import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const hasMaxAmountOfAccountsSelectorFactory = ({ maxAmountOfAccounts = 3 }) => (filter) => createSelector(filter({ enabled: true, hardware: false, custodial: false }), (currentAccounts) => currentAccounts.length >= maxAmountOfAccounts);
const createHasMaxAmountOfAccountsSelectorDefinition = (config) => defineSelectorFactory({
    id: 'hasMaxAmountOfAccounts',
    selectorFactory: hasMaxAmountOfAccountsSelectorFactory(config),
    dependencies: [
        { selector: 'filter' },
    ],
});
export default createHasMaxAmountOfAccountsSelectorDefinition;
